import * as types from './action_types';
import * as UserActions from '../user/actions';
import SubscriptionService from '../../services/subscriber';
import IntraAppMessagingService from '../../services/intra_app_messaging_service';
import DateMaster from '../utils/date_master';

export const fetch = (email) => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.SUBSCRIPTION_RETRIEVING });
      const subscriptionData = await SubscriptionService.fetch(email);
      if (subscriptionData) {
        const subscription = {
          active: subscriptionData.is_active,
          createdAt: DateMaster.parseUTC(subscriptionData.created_at)
        }
        dispatch({ type: types.SUBSCRIPTION_RETRIEVED, subscription });
      }
    } catch(error) {
      dispatch({ type: types.SUBSCRIPTION_ERROR, error });
    }
  }
}

export const resetError = () => {
  return (dispatch) => {
    dispatch({ type: types.SUBSCRIPTION_ERROR_RESET });
  }
}

export const subscribe = (cardToken) => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.SUBSCRIPTION_CREATING });
      const subscriptionData = await SubscriptionService.subscribe(cardToken);
      const subscription = {
        active: subscriptionData.is_active,
        createdAt: DateMaster.parseUTC(subscriptionData.created_at)
      }
      dispatch({ type: types.SUBSCRIPTION_CREATED, subscription });
      dispatch(UserActions.fetchAccount());
    } catch(error) {
      dispatch({ type: types.SUBSCRIPTION_ERROR, error });
    }
  }
}

export const cancel = (email) => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.SUBSCRIPTION_CANCELING });
      await SubscriptionService.cancel(email);
      dispatch({ type: types.SUBSCRIPTION_CANCELED });
      dispatch(UserActions.fetchAccount());
    } catch(error) {
      dispatch({ type: types.SUBSCRIPTION_ERROR, error });
    }
  }
}

export const toggleMobilePaymentSupported = (mobilePaymentSupported, mobilePaymentMethod) => {
  return async(dispatch) => {
    dispatch({ type: types.SUBSCRIPTION_TOGGLE_MOBILE_SUPPORTED, mobilePaymentSupported, mobilePaymentMethod });
  }
}

export const tellMobileAppToPopupPaymentOptions = () => {
  return async(dispatch) => {
    try {
      IntraAppMessagingService.tellMobileAppToPopupPaymentOptions();
    } catch(error) {
      dispatch({ type: types.SUBSCRIPTION_ERROR, error });
    }
  }
}

export const notifyOnSubscriptionPage = () => {
  return async(dispatch) => {
    try {
      IntraAppMessagingService.notifyOnSubscriptionPage();
    } catch(error) {
      dispatch({ type: types.SUBSCRIPTION_ERROR, error });
    }
  }
}

export const processMobilePayment = (paymentToken) => {
  return async(dispatch) => {
    dispatch({ type: types.SUBSCRIPTION_PROCESS_MOBILE_PAYMENT, paymentToken });
  }
}



// WEBPACK FOOTER //
// ./src/stores/subscriptions/actions.js